export default __webpack_public_path__ + "static/content-2ca5fc9961f6585b5ab3b1f5d24e8e80.jpg";